module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "product-analysis"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "downloadMenpiaoData": _vm.downloadMenpiaoData
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('section', {
    staticClass: "search-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productStr),
      expression: "productStr"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名称、编号"
    },
    domProps: {
      "value": (_vm.productStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productStr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "搜索"
    },
    on: {
      "click": function($event) {
        _vm.getData()
      }
    }
  })]), _vm._v(" "), _c('table-component', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  }), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.totalCount / 10),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ad43ea8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/productData/components/product-analysis/ProductAnalysis.vue
// module id = 855
// module chunks = 0